import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import sanitizeHtml from 'sanitize-html';
import Select from './filters/Select';
import Search from './filters/Search';
import { useSettingsContext } from '../contexts/settings';
import Pills from './filters/Pills';
import PostTypePills from './filters/PostTypePills';

const Filters = () => {
	const { tax } = useFiltersContext();
	const settings = useSettingsContext();

	if (settings.multiPostType) {
		return (
			<div className="pfa-filters">
				<div className="pfa-filters__filter pfa-filters__filter--pills">
					<label htmlFor="pfa-filter-post-type" className="pfa-filters__title">
						{settings.i18n.type}
					</label>
					<PostTypePills />
				</div>
				{settings.showSearch && (
					<div className="pfa-filters__filter">
						{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
						<label
							htmlFor="pfa-filter-search"
							className="pfa-filters__title"
							dangerouslySetInnerHTML={{ __html: sanitizeHtml(settings.searchTitle) }}
						/>
						<Search />
					</div>
				)}
			</div>
		);
	}

	const taxEntries = Object.entries(tax);
	const pillTax = taxEntries.filter(([, taxonomy]) => taxonomy.name === 'category');
	const selectTax = taxEntries.filter(([, taxonomy]) => taxonomy.name !== 'category');

	return (
		<div className="pfa-filters">
			{pillTax.length > 0 && (
				<div className="pfa-filters__filter pfa-filters__filter--pills">
					<label htmlFor="pfa-filter-category" className="pfa-filters__title">
						{pillTax[0][1].labels.singular}
					</label>
					<Pills taxonomy={pillTax[0][1]} />
				</div>
			)}
			{selectTax.map(([key, taxonomy]) => {
				return (
					<div className="pfa-filters__filter" key={key}>
						<label
							htmlFor={`pfa-filter-${taxonomy.name}`}
							className="pfa-filters__title"
						>
							{taxonomy.labels.singular}
						</label>
						<Select taxonomy={taxonomy} />
					</div>
				);
			})}
			{settings.showSearch && (
				<div className="pfa-filters__filter">
					{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
					<label
						htmlFor="pfa-filter-search"
						className="pfa-filters__title"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(settings.searchTitle) }}
					/>
					<Search />
				</div>
			)}
		</div>
	);
};

Filters.displayName = 'Filters';

export default Filters;
